import React,{useEffect,useState} from 'react';
import {db} from '../../firebase/firebase.js';
import {doc,onSnapshot,updateDoc} from 'firebase/firestore';
import {useAuth} from '../../auth/AuthContext';

export default function ResellerProfile(){
  const {user}=useAuth();
  const resellerId=user?.uid;

  const[data,setData]=useState({
    name:'',
    email:'',
    phone:'',
    tier:'basic'
  });

  const[saving,setSaving]=useState(false);

  useEffect(()=>{
    if(!resellerId)return;

    const ref=doc(db,'resellers',resellerId);
    const unsub=onSnapshot(ref,(snap)=>{
      if(snap.exists())setData(snap.data());
    });

    return()=>unsub();
  },[resellerId]);

  const updateField=(k)=>(e)=>setData({...data,[k]:e.target.value});

  const save=async()=>{
    setSaving(true);
    await updateDoc(doc(db,'resellers',resellerId),data);
    setSaving(false);
  };

  return(
    <div className="min-h-screen bg-neutral-950 text-white px-6 py-10">
      <div className="max-w-2xl mx-auto">

        <h2 className="text-3xl font-semibold mb-8">Reseller Profile</h2>

        <div className="bg-neutral-900 p-6 rounded-2xl shadow-xl space-y-5">

          <input className="w-full p-3 bg-neutral-800 rounded" placeholder="Name" value={data.name} onChange={updateField('name')}/>
          <input className="w-full p-3 bg-neutral-800 rounded" placeholder="Email" value={data.email} onChange={updateField('email')}/>
          <input className="w-full p-3 bg-neutral-800 rounded" placeholder="Phone" value={data.phone} onChange={updateField('phone')}/>
          <input className="w-full p-3 bg-neutral-800 rounded" placeholder="Tier" value={data.tier} onChange={updateField('tier')}/>

          <button onClick={save} className="w-full py-3 bg-blue-600 rounded-xl hover:bg-blue-700 transition">
            {saving ? "Saving..." : "Save Profile"}
          </button>

        </div>

      </div>
    </div>
  );
}
